import React from 'react';
const IconZapierLogo = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="2" y="2" width="20" height="20" rx="3" fill="#2D2E2E"/>
</svg>

);
};
export default IconZapierLogo;